import { createReactComponent } from './react-component-lib';
import { defineCustomElements } from '@profabric/web-components/loader';
defineCustomElements();
export const PfButton = createReactComponent('pf-button');
export const PfCheckbox = createReactComponent('pf-checkbox');
export const PfDropdown = createReactComponent('pf-dropdown');
export const PfImage = createReactComponent('pf-image');
export const PfPhoneInput = createReactComponent('pf-phone-input');
export const PfSelect = createReactComponent('pf-select');
